import { setSpotConfig, TConfigRow } from '@host-panel/request/config';
import { CSS_TYPES, CssVariablesList, ConfigValue } from '../types';

export async function saveCssVariablesConfig(
  spotId: string,
  spotName: string,
  cssVariables: CssVariablesList
) {
  let configuration: TConfigRow[] = getCssConfiguration(cssVariables[CSS_TYPES.DEFAULT]);
  configuration = [...configuration, ...getCssConfiguration(cssVariables[CSS_TYPES.DARK])];
  configuration = [...configuration, ...getCssConfiguration(cssVariables[CSS_TYPES.MOBILE])];

  return configuration.length && setSpotConfig(spotId, configuration, spotName || spotId);
}

const getCssConfiguration = (cssVariables: { [key: string]: ConfigValue }): TConfigRow[] => {
  return cssVariables
    ? Object.keys(cssVariables).map(key => {
        return {
          db: 'tenant',
          namespace: cssVariables[key].namespace,
          key,
          value: cssVariables[key].value,
          expose: true,
          active: true,
          updated_at: cssVariables[key].updated_at
        };
      })
    : [];
};
